/* ==========================================================================
   CRYSTAL PRINTS - SHARED THEME SCRIPT
   Derived from the design comp by build-theme.py. The comp's MENU,
   GALLERIES and SHAPES arrays are gone: navigation comes from linklists
   and products come from collections, both rendered in Liquid. What is
   left here is behaviour.
   ========================================================================== */

/* --------------------------------------------------------------------------
   1. CRYSTAL SHAPE LIBRARY
   Filters, clip paths and one <symbol> per shape, all on a 200x200 canvas.
   Injected once so both pages share a single copy.
   -------------------------------------------------------------------------- */
var CRYSTAL_DEFS = '' +
'<svg width="0" height="0" aria-hidden="true" focusable="false" style="position:absolute">' +
'<defs>' +
  /* The heart FILLS its box. It used to sit inside it - x .17 to .83, y .25 to
     .86 - so every window measured on a crystal held a heart two thirds that
     size, sitting low, and the hearts previewed the chest and hands of the
     photograph with the face cropped off above. This copy is the one that
     counts: it is injected at the top of <body>, so where the layout also
     defines #clipHeart, url(#clipHeart) finds THIS one first. */
  '<clipPath id="clipHeart" clipPathUnits="objectBoundingBox">' +
    '<path d="M.5 1C.197 .754 0 .557 0 .328C0 .131 .136 0 .303 0C.409 0 .47 .066 .5 .131C.53 .066 .591 0 .697 0C.864 0 1 .131 1 .328C1 .557 .803 .754 .5 1Z"/>' +
  '</clipPath>' +
  /* The 2D heart paperweight stands on its side - point bottom-left, flat
     bottom - so no upright heart fits it. This is its inner face, traced off
     the photograph (trace-side-heart.py). */
  '<clipPath id="clipHeartSide" clipPathUnits="objectBoundingBox">' +
    '<path d="M1.070 .533L1.103 .598L1.112 .666L1.103 .733L1.080 .796L1.040 .850L.994 .898L.952 .946L.894 .975L.820 .976L.768 .998L.709 .997L.654 .996L.605 .997L.556 .996L.509 .995L.463 .996L.414 .997L.364 .996L.310 .997L.251 .998L.183 .999L.104 .999L.010 .999L-.034 .943L-.013 .846L.005 .766L.020 .698L.037 .637L.051 .583L.069 .533L.073 .486L.084 .440L.092 .393L.104 .346L.118 .299L.120 .240L.135 .184L.161 .132L.185 .071L.221 .015L.270 -.025L.322 -.063L.385 -.071L.448 -.074L.509 -.071L.567 -.032L.618 .002L.668 .028L.699 .092L.723 .151L.737 .209L.750 .257L.759 .301L.777 .332L.800 .360L.830 .386L.879 .409L.952 .436L1.017 .478Z"/>' +
  '</clipPath>' +
  '<linearGradient id="gGlass" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#3E6A85" stop-opacity=".95"/>' +
    '<stop offset=".45" stop-color="#1B3446"/>' +
    '<stop offset="1" stop-color="#25485F"/></linearGradient>' +
  '<linearGradient id="gEdge" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#DDEBEF" stop-opacity=".85"/>' +
    '<stop offset=".5" stop-color="#8FBECB" stop-opacity=".35"/>' +
    '<stop offset="1" stop-color="#DDEBEF" stop-opacity=".7"/></linearGradient>' +
  '<linearGradient id="gSheen" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#fff" stop-opacity=".38"/>' +
    '<stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>' +
  '<linearGradient id="gBaseWood" x1="0" y1="0" x2="0" y2="1">' +
    '<stop offset="0" stop-color="#2C3238"/><stop offset="1" stop-color="#12161A"/></linearGradient>' +
  '<linearGradient id="gMetal" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#E3E8EC"/><stop offset=".5" stop-color="#98A3AD"/>' +
    '<stop offset="1" stop-color="#D2D9DE"/></linearGradient>' +
  '<radialGradient id="gLampGlow" cx=".5" cy="1" r=".9">' +
    '<stop offset="0" stop-color="#F0D9A6" stop-opacity=".85"/>' +
    '<stop offset=".55" stop-color="#D9B87A" stop-opacity=".22"/>' +
    '<stop offset="1" stop-color="#D9B87A" stop-opacity="0"/></radialGradient>' +
  '<radialGradient id="gFloor" cx=".5" cy=".5" r=".5">' +
    '<stop offset="0" stop-color="#9FD0DC" stop-opacity=".3"/>' +
    '<stop offset="1" stop-color="#9FD0DC" stop-opacity="0"/></radialGradient>' +

  '<symbol id="sym-wide-iceberg" viewBox="0 0 200 200">' +
    '<ellipse cx="100" cy="180" rx="72" ry="13" fill="url(#gFloor)"/>' +
    '<path d="M26 176C18 130 22 84 40 56L62 42L146 44L168 60C182 92 184 138 176 176Z" fill="url(#gGlass)" stroke="url(#gEdge)" stroke-width="1.6"/>' +
    '<path d="M40 56L62 42L146 44L168 60Z" fill="url(#gSheen)"/>' +
    '<path d="M34 168C28 128 30 92 44 64" stroke="#DDEBEF" stroke-opacity=".4" stroke-width="1.4" fill="none"/>' +
  '</symbol>' +
  '<symbol id="sym-tall-iceberg" viewBox="0 0 200 200">' +
    '<ellipse cx="100" cy="186" rx="56" ry="11" fill="url(#gFloor)"/>' +
    '<path d="M62 182C54 130 52 70 66 34L88 20L122 22L140 40C152 88 150 140 142 182Z" fill="url(#gGlass)" stroke="url(#gEdge)" stroke-width="1.6"/>' +
    '<path d="M66 34L88 20L122 22L140 40Z" fill="url(#gSheen)"/>' +
    '<path d="M70 174C63 128 62 76 72 42" stroke="#DDEBEF" stroke-opacity=".4" stroke-width="1.4" fill="none"/>' +
  '</symbol>' +
  '<symbol id="sym-plaque-lit" viewBox="0 0 200 200">' +
    '<ellipse cx="100" cy="184" rx="76" ry="12" fill="url(#gFloor)"/>' +
    '<rect x="30" y="60" width="140" height="122" fill="url(#gLampGlow)"/>' +
    '<rect x="46" y="22" width="108" height="140" rx="2.5" fill="url(#gGlass)" stroke="url(#gEdge)" stroke-width="1.5"/>' +
    '<rect x="50" y="26" width="100" height="132" rx="1.5" fill="none" stroke="#DDEBEF" stroke-opacity=".22"/>' +
    '<path d="M46 22L154 22L146 30L54 30Z" fill="url(#gSheen)"/>' +
    '<rect x="28" y="160" width="144" height="22" rx="3" fill="url(#gBaseWood)"/>' +
    '<rect x="28" y="160" width="144" height="3" rx="1.5" fill="#DDEBEF" fill-opacity=".16"/>' +
  '</symbol>' +
  '<symbol id="sym-block-3d" viewBox="0 0 200 200">' +
    '<ellipse cx="104" cy="184" rx="58" ry="11" fill="url(#gFloor)"/>' +
    '<path d="M60 28L78 17L158 17L140 28Z" fill="#4A7691" fill-opacity=".85" stroke="url(#gEdge)" stroke-width="1.2"/>' +
    '<path d="M140 28L158 17L158 165L140 176Z" fill="#20415A" stroke="url(#gEdge)" stroke-width="1.2"/>' +
    '<rect x="60" y="28" width="80" height="148" rx="2" fill="url(#gGlass)" stroke="url(#gEdge)" stroke-width="1.5"/>' +
    '<path d="M60 28L140 28L128 44L60 44Z" fill="url(#gSheen)"/>' +
  '</symbol>' +
  '<symbol id="sym-presentation" viewBox="0 0 200 200">' +
    '<ellipse cx="100" cy="180" rx="80" ry="12" fill="url(#gFloor)"/>' +
    '<rect x="24" y="26" width="152" height="112" rx="2.5" fill="url(#gGlass)" stroke="url(#gEdge)" stroke-width="1.5"/>' +
    '<rect x="34" y="36" width="132" height="92" rx="1.5" fill="none" stroke="#DDEBEF" stroke-opacity=".3"/>' +
    '<path d="M24 26L176 26L166 36L34 36Z" fill="url(#gSheen)"/>' +
    '<path d="M42 138L158 138L172 174L28 174Z" fill="url(#gGlass)" stroke="url(#gEdge)" stroke-width="1.4"/>' +
    '<path d="M42 138L158 138L154 146L46 146Z" fill="#fff" fill-opacity=".14"/>' +
  '</symbol>' +
  '<symbol id="sym-heart" viewBox="0 0 200 200">' +
    '<ellipse cx="100" cy="182" rx="52" ry="9" fill="url(#gFloor)"/>' +
    '<path d="M100 42C100 42 96 30 100 24" stroke="#DDEBEF" stroke-opacity=".5" stroke-width="1.4" fill="none"/>' +
    '<circle cx="100" cy="20" r="6" fill="none" stroke="url(#gMetal)" stroke-width="2"/>' +
    '<path d="M100 172C60 142 34 118 34 90C34 66 52 50 74 50C88 50 96 58 100 66C104 58 112 50 126 50C148 50 166 66 166 90C166 118 140 142 100 172Z" fill="url(#gGlass)" stroke="url(#gEdge)" stroke-width="1.6"/>' +
    '<path d="M74 50C56 52 42 66 40 86" stroke="#fff" stroke-opacity=".3" stroke-width="2.4" fill="none" stroke-linecap="round"/>' +
  '</symbol>' +
  '<symbol id="sym-keychain" viewBox="0 0 200 200">' +
    '<ellipse cx="100" cy="186" rx="44" ry="8" fill="url(#gFloor)"/>' +
    '<circle cx="100" cy="26" r="13" fill="none" stroke="url(#gMetal)" stroke-width="3.4"/>' +
    '<rect x="94" y="38" width="12" height="14" rx="3" fill="url(#gMetal)"/>' +
    '<circle cx="100" cy="118" r="62" fill="url(#gGlass)" stroke="url(#gEdge)" stroke-width="1.6"/>' +
    '<path d="M62 90A62 62 0 0 1 128 60" stroke="#fff" stroke-opacity=".3" stroke-width="3" fill="none" stroke-linecap="round"/>' +
  '</symbol>' +
'</defs></svg>';

/* Routes are handed over by layout/theme.liquid in window.CP. BASE stays
   for the shared code that still concatenates it, and is always ''. */
var BASE = '';
var ROUTE = {};

function initBase(){
  /* Shopify owns the routes. layout/theme.liquid writes them into window.CP
     so nothing here has to guess a path from the folder depth. */
  var cp = window.CP || {};
  var r  = cp.routes || {};
  BASE = '';
  ROUTE = {
    home:   r.root   || '/',
    cart:   r.cart   || '/cart',
    search: r.search || '/search',
    upload: cp.upload || '/pages/upload'
  };
}


document.addEventListener('DOMContentLoaded', function(){
  document.body.insertAdjacentHTML('afterbegin', CRYSTAL_DEFS);
});


/* --------------------------------------------------------------------------
   4. NAVIGATION (desktop mega + mobile accordion from the same data)
   -------------------------------------------------------------------------- */
function initNav(){
  /* Liquid rendered .nav__list and .dnav from the store's linklists, so
     from here down this function only binds behaviour to markup that
     already exists. The comp generated all of it from a MENU array. */
  var nav = document.getElementById('mainNav');
  var drawerNav = document.getElementById('drawerNav');
  if (!nav || !nav.querySelector('.nav__list')) return;
  var desktop = window.matchMedia('(min-width:1021px)');

  var items = [].slice.call(nav.querySelectorAll('.nav__item'));
  function open(li){
    items.forEach(function(o){
      var on = o === li;
      o.toggleAttribute('data-open', on);
      o.querySelector('.nav__link').setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  function closeAll(){ open(null); }

  items.forEach(function(li){
    li.querySelector('.nav__link').addEventListener('click', function(e){
      e.stopPropagation();
      /* An item with a menu under it is a link now. On a desktop the panel is
         already open from the hover, so the click does what the customer asked
         for and follows the link. Without hover the first tap opens the panel -
         otherwise a phone could never see the menu at all. */
      /* Reviews, Blog: nothing opens under them, so a tap is just a link -
         on an iPad (no hover) the first tap used to be swallowed */
      if (!li.querySelector('.mega')) return;
      var href = this.getAttribute('href');
      if (href && href !== '#' && desktop.matches && window.matchMedia('(hover:hover)').matches) return;
      if (href) e.preventDefault();
      li.hasAttribute('data-open') ? closeAll() : open(li);
    });
    var hover = window.matchMedia('(hover:hover)');
    li.addEventListener('mouseenter', function(){ if (desktop.matches && hover.matches) open(li); });
    li.addEventListener('mouseleave', function(){ if (desktop.matches && hover.matches) closeAll(); });
  });
  document.addEventListener('click', function(e){ if (!nav.contains(e.target)) closeAll(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeAll(); });
  nav.addEventListener('focusout', function(e){ if (!nav.contains(e.relatedTarget)) closeAll(); });

  if (!drawerNav) return;
  [].forEach.call(drawerNav.querySelectorAll('.dnav__row'), function(row){
    row.querySelector('.dnav__top').addEventListener('click', function(){
      var was = row.hasAttribute('data-open');
      [].forEach.call(drawerNav.querySelectorAll('.dnav__row'), function(r){
        r.removeAttribute('data-open');
        r.querySelector('.dnav__top').setAttribute('aria-expanded', 'false');
      });
      if (!was){
        row.setAttribute('data-open', '');
        row.querySelector('.dnav__top').setAttribute('aria-expanded', 'true');
      }
    });
  });
}


function initCarousel(){
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="%s"/></svg>';
  [].forEach.call(document.querySelectorAll('.car'), function(car){
    var track = car.querySelector('.car__track');
    if (!track || car.querySelector('.car__nav')) return;

    var nav = document.createElement('div');
    nav.className = 'car__nav';
    nav.innerHTML =
      '<button type="button" class="car__btn car__btn--prev" aria-label="Previous">' +
        ARROW.replace('%s', 'm14 6-6 6 6 6') + '</button>' +
      '<button type="button" class="car__btn car__btn--next" aria-label="Next">' +
        ARROW.replace('%s', 'm10 6 6 6-6 6') + '</button>';
    car.insertBefore(nav, car.firstChild);

    var bar = document.createElement('div');
    bar.className = 'car__bar';
    bar.innerHTML = '<i></i>';
    car.appendChild(bar);
    var fill = bar.firstChild;

    var prev = nav.querySelector('.car__btn--prev');
    var next = nav.querySelector('.car__btn--next');

    function step(){
      var card = track.firstElementChild;
      if (!card) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function sync(){
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft > max - 4;
      /* the bar shows the visible fraction, positioned by how far along we are */
      var frac = track.clientWidth / track.scrollWidth;
      fill.style.width = (frac * 100) + '%';
      fill.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) *
        ((1 - frac) / frac) * 100 : 0) + '%)';
      /* nothing to scroll: hide the whole apparatus */
      var idle = max < 4;
      nav.style.display = idle ? 'none' : '';
      bar.style.display = idle ? 'none' : '';
    }
    prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
    next.addEventListener('click', function(){ track.scrollBy({left: step(), behavior:'smooth'}); });
    track.addEventListener('scroll', sync);
    window.addEventListener('resize', sync);
    /* the cards are injected by initGalleries, and images change scrollWidth as
       they decode, so re-measure once things settle */
    sync();
    setTimeout(sync, 60);
    if (document.readyState !== 'complete') window.addEventListener('load', sync);

    /* park the arrows level with the middle of the artwork */
    function place(){
      var art = track.querySelector('.gcard__img, .pcard__img, img');
      var h = art ? art.getBoundingClientRect().height : track.clientHeight;
      nav.style.top = (h / 2 - 21) + 'px';
    }
    place(); setTimeout(place, 60);
    window.addEventListener('resize', place);
    if (document.readyState !== 'complete') window.addEventListener('load', place);
  });
}


/* --------------------------------------------------------------------------
   6. PHOTO TRAY
   Single source of truth: the selected photo is written to one CSS custom
   property on <body>, so every .crystal__eng on the page repaints at once.
   Persisted to localStorage so the tray survives navigation.
   NOTE for build: localStorage + data URLs is fine for previewing, but a real
   order needs the full-resolution file in actual storage with a URL on the
   cart line item - see the handover notes.
   -------------------------------------------------------------------------- */
/* Every photograph the customer picks, by name, as the file itself. The tray
   keeps only a 720px copy (and clears its picker the moment it has read it), so
   without this the order got the small copy - or, on the product page, nothing
   at all for a photo shown from the tray. Read in the capture phase, before any
   input is emptied. */
var CP_FILES = {};
function cpRemember(list){
  [].forEach.call(list || [], function(f){
    if (f && /^image\//.test(f.type)) CP_FILES[f.name] = f;
  });
}
document.addEventListener('change', function(e){
  var t = e.target;
  if (t && t.type === 'file' && !t.hasAttribute('data-design-file')) cpRemember(t.files);
}, true);

function initTray(){
  var picker = document.getElementById('filePicker');
  if (!picker) return;

  var KEY = 'cp_tray_v1', MAX = 8, EDGE = 720;
  var store = load();

  function load(){
    try { var d = JSON.parse(localStorage.getItem(KEY)); return d && d.items ? d : {items:[],active:0}; }
    catch(e){ return {items:[],active:0}; }
  }
  function save(){ try { localStorage.setItem(KEY, JSON.stringify(store)); } catch(e){} }

  function shrink(file){
    return new Promise(function(res, rej){
      var r = new FileReader();
      r.onerror = rej;
      r.onload = function(){
        var img = new Image();
        img.onerror = rej;
        img.onload = function(){
          var s = Math.min(1, EDGE / Math.max(img.width, img.height));
          var c = document.createElement('canvas');
          c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          res({ src:c.toDataURL('image/jpeg', .86), name:file.name, sample:false });
        };
        img.src = r.result;
      };
      r.readAsDataURL(file);
    });
  }

  function add(list){ store.items = list.concat(store.items).slice(0, MAX); store.active = 0; save(); render(); }

  function paint(){
    var it = store.items[store.active];
    if (it){
      /* the preview editor owns --photo wherever it is on the page: it
         composes every photograph in the crystal and the engraved line */
      if (!document.querySelector('[data-photo-tools]'))
        document.body.style.setProperty('--photo', 'url("' + it.src + '")');
      document.body.setAttribute('data-has-photo', '');
    } else {
      document.body.style.removeProperty('--photo');
      document.body.removeAttribute('data-has-photo');
    }
    [].forEach.call(document.querySelectorAll('[data-count]'), function(el){
      el.textContent = store.items.length;
    });
    /* the upload flow needs to know the moment a photo lands, and the CSS gate
       alone cannot scroll the page */
    document.dispatchEvent(new CustomEvent('cp:photo', { detail:{ count:store.items.length } }));
  }

  function render(){
    [].forEach.call(document.querySelectorAll('[data-strip]'), function(strip){
      strip.innerHTML = '';
      var addBtn = document.createElement('button');
      addBtn.type = 'button'; addBtn.className = 'chip chip--add';
      addBtn.setAttribute('aria-label', 'Add a photo');
      addBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>';
      addBtn.onclick = function(){ picker.click(); };
      strip.appendChild(addBtn);

      store.items.forEach(function(it, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'chip' + (it.sample ? ' chip--sample' : '');
        b.setAttribute('aria-pressed', i === store.active ? 'true' : 'false');
        b.setAttribute('aria-label', 'Preview ' + (it.name || 'photo ' + (i + 1)));
        b.innerHTML = '<img src="' + it.src + '" alt=""><span class="chip__x" role="presentation">&times;</span>';
        b.onclick = function(e){
          if (e.target.classList.contains('chip__x')){
            store.items.splice(i, 1);
            if (store.active >= store.items.length) store.active = 0;
          } else { store.active = i; }
          save(); render();
        };
        strip.appendChild(b);
      });
    });
    paint();
  }

  /* "Clear all" had a button and nothing listening to it */
  [].forEach.call(document.querySelectorAll('[data-clear]'), function(b){
    b.addEventListener('click', function(){
      store.items = []; store.active = 0; save(); render();
    });
  });

  picker.addEventListener('change', function(){
    var files = [].slice.call(picker.files).filter(function(f){ return /^image\//.test(f.type); });
    if (files.length) Promise.all(files.map(shrink)).then(add).catch(function(){
      alert('That file could not be read. Try a JPG or PNG.');
    });
    picker.value = '';
  });

  [].forEach.call(document.querySelectorAll('[data-drop]'), function(drop){
    drop.addEventListener('click', function(){ picker.click(); });
    ['dragenter','dragover'].forEach(function(ev){
      drop.addEventListener(ev, function(e){ e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave','drop'].forEach(function(ev){
      drop.addEventListener(ev, function(){ drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function(e){
      e.preventDefault();
      var files = [].slice.call(e.dataTransfer.files).filter(function(f){ return /^image\//.test(f.type); });
      cpRemember(files);
      if (files.length) Promise.all(files.map(shrink)).then(add);
    });
  });

  /* synthetic samples so the etch effect is visible without an upload */
  function sample(kind){
    var c = document.createElement('canvas'); c.width = c.height = 520;
    var x = c.getContext('2d');
    var g = x.createLinearGradient(0, 0, 0, 520);
    g.addColorStop(0, '#f2f2f2'); g.addColorStop(1, '#c9c9c9');
    x.fillStyle = g; x.fillRect(0, 0, 520, 520);
    x.fillStyle = '#2b2b2b';
    if (kind === 'portrait'){
      x.beginPath(); x.ellipse(260, 300, 150, 190, 0, Math.PI, 0); x.fill();
      x.beginPath(); x.ellipse(260, 180, 86, 104, 0, 0, Math.PI * 2); x.fill();
      x.fillStyle = 'rgba(255,255,255,.28)';
      x.beginPath(); x.ellipse(228, 158, 30, 40, 0, 0, Math.PI * 2); x.fill();
    } else {
      x.beginPath(); x.ellipse(260, 330, 132, 120, 0, 0, Math.PI * 2); x.fill();
      x.beginPath(); x.ellipse(260, 190, 96, 86, 0, 0, Math.PI * 2); x.fill();
      x.beginPath(); x.moveTo(186, 132); x.lineTo(160, 44); x.lineTo(232, 110); x.fill();
      x.beginPath(); x.moveTo(334, 132); x.lineTo(360, 44); x.lineTo(288, 110); x.fill();
      x.fillStyle = '#f2f2f2';
      x.beginPath(); x.ellipse(228, 182, 13, 17, 0, 0, Math.PI * 2); x.fill();
      x.beginPath(); x.ellipse(292, 182, 13, 17, 0, 0, Math.PI * 2); x.fill();
    }
    return { src:c.toDataURL('image/jpeg', .9), name:kind + ' sample', sample:true };
  }

  [].forEach.call(document.querySelectorAll('[data-sample]'), function(btn){
    btn.addEventListener('click', function(){
      var have = store.items.filter(function(i){ return i.sample; }).length;
      add([ sample(have % 2 ? 'pet' : 'portrait') ]);
    });
  });

  render();
}


/* --------------------------------------------------------------------------
   7. MISC: review rail, drawer, reveal-on-scroll
   -------------------------------------------------------------------------- */
function initRail(){
  var track = document.getElementById('revTrack');
  if (!track) return;
  [].forEach.call(document.querySelectorAll('[data-rail]'), function(b){
    b.addEventListener('click', function(){
      var card = track.querySelector('.rev');
      track.scrollBy({ left:(card ? card.offsetWidth + 20 : 340) * +b.dataset.rail, behavior:'smooth' });
    });
  });
}

function initDrawer(){
  var d = document.getElementById('drawer'), b = document.getElementById('burger');
  if (!d || !b) return;
  function set(v){
    v ? d.setAttribute('data-open', '') : d.removeAttribute('data-open');
    b.setAttribute('aria-expanded', v ? 'true' : 'false');
    document.body.style.overflow = v ? 'hidden' : '';
  }
  b.addEventListener('click', function(){ set(!d.hasAttribute('data-open')); });
  d.addEventListener('click', function(e){
    if (e.target.closest('[data-close]')) set(false);
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') set(false); });
}

function initReveal(){
  var els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)){
    [].forEach.call(els, function(e){ e.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function(rows){
    rows.forEach(function(r){
      if (r.isIntersecting){ r.target.classList.add('is-in'); io.unobserve(r.target); }
    });
  }, { rootMargin:'0px 0px -8% 0px', threshold:.12 });
  [].forEach.call(els, function(e, i){
    e.style.transitionDelay = (i % 4) * 70 + 'ms';
    io.observe(e);
  });
}

/* --------------------------------------------------------------------------
   8. INTERIOR PAGE BEHAVIOUR
   -------------------------------------------------------------------------- */

function initTabs(){
  [].forEach.call(document.querySelectorAll('[data-tabs]'), function(group){
    var host = document.getElementById(group.getAttribute('data-tabs'));
    if (!host) return;
    var tabs = [].slice.call(group.querySelectorAll('[data-tab]'));
    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        tabs.forEach(function(o){
          o.setAttribute('aria-selected', o === t ? 'true' : 'false');
        });
        [].forEach.call(host.querySelectorAll('[data-view]'), function(v){
          v.toggleAttribute('data-on', v.getAttribute('data-view') === t.getAttribute('data-tab'));
        });
        /* a hidden preview has no size to draw to - it gets one now */
        document.dispatchEvent(new CustomEvent('cp:stage'));
      });
    });
  });
}

/* Option swatches. Each button carries data-delta, the buy box carries
   data-base, and the total is recomputed from whatever is pressed - which is
   how size and base stop being separate products. */
function initQty(){
  [].forEach.call(document.querySelectorAll('.qty'), function(q){
    var input = q.querySelector('input');
    [].forEach.call(q.querySelectorAll('button'), function(b){
      b.addEventListener('click', function(){
        input.value = Math.max(1, (+input.value || 1) + (+b.getAttribute('data-step')));
      });
    });
  });
}

function initThumbs(){
  [].forEach.call(document.querySelectorAll('[data-thumbs]'), function(list){
    var target = document.getElementById(list.getAttribute('data-thumbs'));
    if (!target) return;
    var btns = [].slice.call(list.querySelectorAll('.thumb'));
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        btns.forEach(function(o){
          o.setAttribute('aria-current', o === b ? 'true' : 'false');
        });
        var img = b.querySelector('img');
        /* srcset outranks src, so it has to go or the picture never
           changes. data-full carries the large URL - the thumb's own
           src is only a 260px crop. */
        target.removeAttribute('srcset');
        target.removeAttribute('sizes');
        target.src = b.getAttribute('data-full') || img.getAttribute('src');
        target.alt = img.getAttribute('alt');
        /* picking a studio photo should show the studio photo */
        var tab = document.querySelector('[data-tab="photo"]');
        if (tab) tab.click();
      });
    });
  });
}

/* COMP LINK RESOLUTION - none of this ships.
   The hrefs in MENU and SHAPES are the real crystalprints.com paths on purpose:
   they double as the redirect map for the migration. Nothing serves those paths
   while this is a static comp, so each one is pointed at whichever demo page
   stands in for that template, with the real path kept on data-live-url.

   This used to bail out unless the host was localhost or file:// - which meant
   that the moment the comp went up on a real URL, all 92 menu links reverted to
   absolute paths like /gifts/anniversary-gifts/ and every one 404'd. It has to
   run wherever the comp is deployed.

   The replacements are RELATIVE, never root-absolute, so the comp also works
   from a subdirectory (projects.quanrio.com/crystal/) and not just a domain root.

   In Shopify, Liquid emits the real URLs and this function does not exist. */
/* Step 2 is revealed by CSS the instant body[data-has-photo] appears. All this
   adds is the scroll - without it the shapes unlock below the fold and the
   customer has no idea anything happened. Only fires on the first photo, so
   swapping pictures later does not yank the page around. */
function initUploadFlow(){
  var gate = document.querySelector('[data-lock]');
  if (!gate) return;
  var jumped = false;
  document.addEventListener('cp:photo', function(e){
    if (jumped || !e.detail.count) return;
    jumped = true;
    var step2 = document.getElementById('step2');
    if (!step2) return;
    /* let the reveal paint first, then move */
    setTimeout(function(){
      step2.scrollIntoView({ behavior:'smooth', block:'start' });
    }, 90);
  });
}



document.addEventListener('DOMContentLoaded', function(){
  initBase();       /* first: everything below reads ROUTE */
  initNav();        /* behaviour only - Liquid rendered the markup */
  initCarousel();
  initTray();
  initRail();
  initDrawer();
  initTabs();
  initVariants();   /* replaces the comp's fake price-delta swatches */
  initQty();
  initThumbs();
  initPhotoField();
  initPdpPreview();
  initAddons();
  initSearch();
  initPhotoTools();
  initFacets();
  initShapePick();  /* AFTER initTray: it reads the tray's chips */
  initUploadFlow(); /* AFTER initTray: initTray fires cp:photo once as it
                       paints stored photos, and the flow must not hear
                       that one or a returning visitor gets scrolled */
  initReveal();
});


/* ==========================================================================
   THEME-ONLY BEHAVIOUR
   Everything above is shared with the design comp. Everything below exists
   because a real store has variants, a real cart and real filters, which the
   comp only mimed.
   ========================================================================== */

/* --------------------------------------------------------------------------
   Variant picker. The comp added up fake price deltas from data-delta; here the
   swatches drive a real <select name="id">, so the price, the compare-at price
   and the availability of the Add to cart button all come from the variant.
   -------------------------------------------------------------------------- */
function initVariants(){
  var form = document.getElementById('ProductForm');
  if (!form) return;
  var select = form.querySelector('[data-variant-select]');
  if (!select) return;

  var groups = [].slice.call(form.querySelectorAll('[data-opt]'));
  var opts   = [].slice.call(select.options);

  /* A product with only the default variant renders no swatch groups, so the
     chosen combination was the empty string and matched no option's
     data-options ("Default Title") - which put "Unavailable" and a disabled
     button on EVERY single-variant product in the catalogue. With nothing to
     choose, Liquid's own price and availability are already right. */
  if (!groups.length) return;

  /* an option group is either swatches or, when the labels are long - the
     block's ten sizes - a dropdown. Both answer the same question. */
  function chosen(){
    return groups.map(function(g){
      var sel = g.querySelector('[data-opt-select]');
      if (sel) return sel.value;
      var on = g.querySelector('.swatch[aria-pressed="true"]');
      return on ? on.getAttribute('data-value') : '';
    });
  }

  function apply(){
    var want = chosen().join(' ~~ ');
    var match = null;
    opts.some(function(o){
      if (o.getAttribute('data-options') === want){ match = o; return true; }
      return false;
    });
    /* no exact match (an impossible combination) - leave the selection alone
       but make it obvious the customer cannot buy it */
    var btn   = form.querySelector('[data-add-btn]');
    var label = form.querySelector('[data-add-label]');

    if (match){
      select.value = match.value;
      var price = match.getAttribute('data-price');
      var comp  = match.getAttribute('data-compare');
      /* b/span/s only: the variant <option>s carry data-price and data-compare
         too, and a bare [data-compare] selector blanked the first option */
      [].forEach.call(document.querySelectorAll('b[data-price], span[data-price]'), function(el){
        el.textContent = price;
      });
      var cs = document.querySelector('s[data-compare]');
      if (cs){ cs.textContent = comp || ''; cs.hidden = !comp; }
      var sv = document.querySelector('[data-save]');
      if (sv) sv.hidden = !comp;
      if (btn){ btn.disabled = match.disabled; }
      if (label) label.textContent = match.disabled ? 'Sold out' : 'Add to cart';
      cpTotal(form);
    } else {
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Unavailable';
    }
  }

  groups.forEach(function(group){
    var sel = group.querySelector('[data-opt-select]');
    if (sel) sel.addEventListener('change', apply);
    var btns = [].slice.call(group.querySelectorAll('.swatch'));
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        btns.forEach(function(o){ o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        var out = group.querySelector('[data-opt-value]');
        if (out) out.textContent = b.getAttribute('data-value');
        apply();
      });
    });
  });

  apply();
}


/* --------------------------------------------------------------------------
   The photo field is a real <input type="file" name="properties[Your photo]">,
   so the file reaches the order. This shows the customer what they attached -
   a line of text was the only feedback before, which is no way to tell whether
   you picked the right picture. Shared by the product page and step 3 of the
   upload page: same .pfile markup, one painter.
   -------------------------------------------------------------------------- */
function cpPaintFile(file, note){
  var wrap = document.querySelector('[data-photo-preview]');
  if (!wrap) return;
  var nm  = wrap.querySelector('[data-photo-name]');
  var sz  = wrap.querySelector('[data-photo-size]');

  /* no thumbnail any more - the crystal above IS the preview, and the little
     copy of it could only ever be a broken image for a tray photo restored
     from a previous visit */
  if (!file){
    wrap.hidden = true;
    return;
  }
  if (nm) nm.textContent = file.name;
  if (sz){
    sz.textContent = note ||
      (Math.max(1, Math.round(file.size / 1024)) + ' KB · attached to your order');
  }
  wrap.hidden = false;
}

function initPhotoField(){
  var input = document.querySelector('[data-photo-input]');
  if (!input) return;
  input.addEventListener('change', function(){
    cpPaintFile(input.files && input.files[0]);
  });
  var clear = document.querySelector('[data-photo-clear]');
  if (clear) clear.addEventListener('click', function(){
    input.value = '';
    cpPaintFile(null);
  });
}


/* --------------------------------------------------------------------------
   Collection filters. Shopify's filter inputs are a plain GET form; without JS
   they need an Apply button (there is one in a <noscript>). With JS, ticking a
   box submits, which is what shoppers expect.
   -------------------------------------------------------------------------- */
function initFacets(){
  var form = document.getElementById('FacetForm');
  if (!form) return;

  /* form.elements, not querySelectorAll: the Sort by select sits OUTSIDE the
     form and is attached to it with form="FacetForm", so its change event never
     bubbled to the form and choosing a sort order did nothing at all. Anything
     the form submits is in form.elements, wherever it lives in the document. */
  [].forEach.call(form.elements, function(el){
    if (el.type === 'submit' || el.type === 'hidden') return;
    el.addEventListener('change', function(){ form.submit(); });
  });
}


/* --------------------------------------------------------------------------
   PRODUCT PAGE: the "Your photo in it" preview.

   The stage was drawing <svg><use href="#sym-block-3d"> - a symbol that lived
   in the comp's JavaScript sprite, which this build cuts. The tab opened onto
   an empty stage on every product. Liquid renders a real photograph of the
   empty crystal now. All this does is bring the preview forward when the
   customer picks a photo or types the engraving - what gets DRAWN is
   initPhotoTools' business, because that is where the photographs, their
   positions and the engraved line are held.
   -------------------------------------------------------------------------- */
function initPdpPreview(){
  var crystal = document.querySelector('[data-pdp-preview]');
  if (!crystal) return;

  var tab   = document.querySelector('[data-tab="preview"]');
  var input = document.querySelector('[data-photo-input]');
  var text  = document.querySelector('[data-engraved-text]');

  function show(){ if (tab && tab.getAttribute('aria-selected') !== 'true') tab.click(); }

  if (input) input.addEventListener('change', function(){
    var f = input.files && input.files[0];
    if (f && /^image\//.test(f.type)) show();
  });

  if (text) text.addEventListener('input', function(){
    if (text.value) show();
  });
}


/* --------------------------------------------------------------------------
   PREVIEW TOOLS: zoom, nudge, rotate, reset, remove the background.

   crystalprints.com has this toolbar under its preview and the client asked for
   the same experience. Everything here changes the PREVIEW only - the file on
   the order is always the untouched original, because that is what the artists
   work from.

   How it works: one canvas is the single source of the preview. Every control
   re-draws the source photo into it with the current zoom, offset and rotation,
   and the result becomes --photo on <body>, which is what every .crystal__eng
   on the page paints. So the product page's big preview and all 33 tiles on the
   upload page stay in step with one repaint.

   The photo is drawn to FIT the square, never to fill it: a crystal is engraved
   with the whole picture, and cropping the sides off a family in the preview is
   the one thing a preview must not do.
   -------------------------------------------------------------------------- */

/* Loading the background remover is worth a paragraph. A plain
   import('https://…') is right, works locally, and is broken on the live store:
   Shopify minifies theme JavaScript as it serves it, and its bundler rewrites
   every dynamic import into __toESM(require("…")) - a CommonJS require of a URL,
   which throws the instant it runs. That is why the button answered "could not
   remove the background" in a few milliseconds while the library itself was
   fine. Handing the import to a module <script> as source text keeps it out of
   the minifier's reach: to that bundler it is an ordinary string. */
var CP_BG_CDN = 'https://cdn.jsdelivr.net/npm/@imgly/background-removal@1.5.5/+esm';
function cpLoadRemover(){
  if (window.cpBgReady) return window.cpBgReady;
  window.cpBgReady = new Promise(function(resolve, reject){
    var settled = false;
    function ok(m){ if (!settled){ settled = true; resolve(m); } }
    function no(e){ if (!settled){ settled = true; reject(e); } }
    window.addEventListener('cp:bg', function(){ ok(window.cpBg); }, { once: true });

    var s = document.createElement('script');
    s.type = 'module';
    s.textContent = 'import * as m from "' + CP_BG_CDN + '";' +
                    'window.cpBg = m; window.dispatchEvent(new Event("cp:bg"));';
    s.onerror = second;
    document.head.appendChild(s);
    /* the module itself is small - if it is not in by now something blocked it */
    setTimeout(second, 20000);

    /* second way in, for the same reason as the first: the URL only ever exists
       as a string, so nothing that rewrites JavaScript on the way to the browser
       can see an import to rewrite */
    function second(){
      if (settled) return;
      try { (new Function('u', 'return import(u)'))(CP_BG_CDN).then(ok, no); }
      catch (e) { no(e); }
    }
  });
  return window.cpBgReady;
}

/* The cut-out comes back the size of the original with a lot of nothing round
   the edges. Shrink it to preview size and crop to what is actually left, so
   the subject fills the engraving window instead of floating in the middle of
   the photo's old margins. */
function cpTrim(img, edge){
  var s = Math.min(1, edge / Math.max(img.width, img.height));
  var w = Math.max(1, Math.round(img.width * s));
  var h = Math.max(1, Math.round(img.height * s));
  var c = document.createElement('canvas');
  c.width = w; c.height = h;
  var x = c.getContext('2d');
  x.drawImage(img, 0, 0, w, h);
  var d;
  try { d = x.getImageData(0, 0, w, h).data; } catch (e) { return c; }
  var x0 = w, y0 = h, x1 = -1, y1 = -1;
  for (var y = 0; y < h; y++){
    for (var i = 0; i < w; i++){
      if (d[(y * w + i) * 4 + 3] > 24){
        if (i < x0) x0 = i;
        if (i > x1) x1 = i;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
      }
    }
  }
  if (x1 < 0) return c;                      /* nothing left - keep the frame */
  var tw = x1 - x0 + 1, th = y1 - y0 + 1;
  var o = document.createElement('canvas');
  o.width = tw; o.height = th;
  o.getContext('2d').drawImage(c, x0, y0, tw, th, 0, 0, tw, th);
  return o;
}

/* The model is the good way to take a background out, and it is not always
   available: a blocked CDN, a driver that throws on the GPU path, a machine
   that runs out of memory. This is the plain-studio-backdrop case done by hand -
   flood the four edges while the colour holds, stop at the subject. It refuses
   the job unless the four corners agree on a colour and it ends up clearing
   between a twentieth and four fifths of the picture, so a busy photograph is
   left exactly as it was rather than half eaten. */
function cpFlatCut(img, edge){
  var s = Math.min(1, edge / Math.max(img.width, img.height));
  var w = Math.max(1, Math.round(img.width * s));
  var h = Math.max(1, Math.round(img.height * s));
  var c = document.createElement('canvas');
  c.width = w; c.height = h;
  var x = c.getContext('2d');
  x.drawImage(img, 0, 0, w, h);
  var id;
  try { id = x.getImageData(0, 0, w, h); } catch (e) { return null; }
  var d = id.data, ref = [0, 0, 0], spread = 0, i, j;
  var corners = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + w - 1) * 4];
  for (i = 0; i < 4; i++){
    ref[0] += d[corners[i]] / 4;
    ref[1] += d[corners[i] + 1] / 4;
    ref[2] += d[corners[i] + 2] / 4;
  }
  for (i = 0; i < 4; i++){
    spread = Math.max(spread, Math.abs(d[corners[i]] - ref[0])
                            + Math.abs(d[corners[i] + 1] - ref[1])
                            + Math.abs(d[corners[i] + 2] - ref[2]));
  }
  if (spread > 90) return null;                   /* not one plain backdrop */

  var seen = new Uint8Array(w * h), stack = [], n = 0, TOL = 66;
  for (i = 0; i < w; i++){ stack.push(i); stack.push((h - 1) * w + i); }
  for (j = 0; j < h; j++){ stack.push(j * w); stack.push(j * w + w - 1); }
  while (stack.length){
    var p = stack.pop();
    if (seen[p]) continue;
    seen[p] = 1;
    var k = p * 4;
    if (Math.abs(d[k] - ref[0]) + Math.abs(d[k + 1] - ref[1])
      + Math.abs(d[k + 2] - ref[2]) > TOL) continue;
    d[k + 3] = 0; n++;
    var px = p % w, py = (p - px) / w;
    if (px > 0) stack.push(p - 1);
    if (px < w - 1) stack.push(p + 1);
    if (py > 0) stack.push(p - w);
    if (py < h - 1) stack.push(p + w);
  }
  var frac = n / (w * h);
  if (frac < 0.05 || frac > 0.85) return null;
  x.putImageData(id, 0, 0);
  return c;
}

function initPhotoTools(){
  var bar = document.querySelector('[data-photo-tools]');
  if (!bar) return;

  var status = bar.querySelector('[data-ptool-status]');
  var spin   = bar.querySelector('[data-ptool-spin]');
  var strip  = bar.querySelector('[data-photo-layers]');
  var btn    = bar.querySelector('[data-ptool="cutout"]');
  var baseNote = status ? status.textContent : '';
  var EDGE = 900;                /* the preview never needs more */
  var BAND = 0.17;               /* foot of the window, kept for the engraving */

  /* one entry per photograph in the crystal, each carrying its own position */
  var layers = [];
  var active = 0;
  var owns = false;              /* true once photos came from this form's input */
  var textIn = document.querySelector('[data-engraved-text]');
  /* one entry per LINE of engraving, each with its own size and position -
     "text ka size chota bara karne ka aur agr multiple text add karna ho" */
  var texts = [];
  var selText = -1;              /* -1: a photograph is selected, else a line */

  /* The engraving is shown in the font the customer picked, because a font
     dropdown that changes nothing on screen is a font dropdown nobody trusts.
     System faces where there is one; the script face is fetched only if it is
     asked for, and falls back to the system's handwriting if it cannot be. */
  var fontIn = document.querySelector('[data-font-select]');
  var FONTS = {
    'arial': 'Arial, Helvetica, sans-serif',
    'georgia': 'Georgia, "Times New Roman", serif',
    'times new roman': '"Times New Roman", Times, serif',
    'dancing script': '"Dancing Script", "Segoe Script", "Bradley Hand", cursive',
    'brush script': '"Brush Script MT", "Segoe Script", cursive'
  };

  /* the CSS font stack for a dropdown value - a line's own, or the main one */
  function chosenFont(value){
    var raw = String(value == null ? (fontIn ? fontIn.value : '') : value).trim();
    var v = raw.toLowerCase();
    if (FONTS[v]) return FONTS[v];
    if (v && v.indexOf('artist') < 0 && v !== 'none')
      return '"' + raw + '", Georgia, serif';
    return String(getComputedStyle(document.documentElement)
             .getPropertyValue('--serif') || '').trim() || 'Georgia, serif';
  }

  /* canvas draws with whatever is loaded at that instant, so the face has to be
     in before the repaint - and document.fonts.load wants ONE family, not a
     stack. Draw immediately with what there is, draw again when it arrives. */
  function faceReady(value, then){
    if (!document.fonts || !document.fonts.load) return;
    var fam = chosenFont(value).split(',')[0].trim();
    try { document.fonts.load('60px ' + fam).then(then, function(){}); } catch (e){}
  }

  function useFont(value){
    var v = String(value || '').toLowerCase().trim();
    var l = document.getElementById('cpScriptFont');
    if (v === 'dancing script' && !l){
      l = document.createElement('link');
      l.id = 'cpScriptFont';
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
      l.onload = function(){ faceReady(value, paint); };
      document.head.appendChild(l);
    } else {
      faceReady(value, paint);
    }
    paint();
  }

  if (fontIn) fontIn.addEventListener('change', function(){ useFont(fontIn.value); });

  /* "agr text ki 2 layers hain to dono layers ka font family alag alag select
     ho saqe". The Font dropdown is line 1's; every further line gets its own,
     cloned from it, under it - "Same as line 1" until the customer picks - and
     each reaches the order as "Font line 2", "Font line 3". */
  var lineFonts = null;
  function syncFontPickers(){
    if (!fontIn) return;
    var n = texts.length;
    if (!lineFonts){
      lineFonts = document.createElement('div');
      lineFonts.setAttribute('data-line-fonts', '');
      var host = fontIn.closest('.field') || fontIn.parentNode;
      host.parentNode.insertBefore(lineFonts, host.nextSibling);
    }
    var have = lineFonts.querySelectorAll('[data-line-font]');
    for (var k = have.length - 1; k >= Math.max(0, n - 1); k--){
      have[k].closest('.field').remove();
    }
    for (var i = have.length + 1; i < n; i++){
      var f = document.createElement('div');
      f.className = 'field';
      var lab = document.createElement('label');
      lab.className = 'label';
      lab.htmlFor = 'lineFont' + (i + 1);
      lab.textContent = 'Font — line ' + (i + 1);
      var sel = fontIn.cloneNode(true);
      sel.removeAttribute('data-font-select');
      sel.id = 'lineFont' + (i + 1);
      sel.name = 'properties[Font line ' + (i + 1) + ']';
      sel.setAttribute('data-line-font', String(i));
      var same = document.createElement('option');
      same.value = '';
      same.textContent = 'Same as line 1';
      sel.insertBefore(same, sel.firstChild);
      sel.value = '';
      sel.disabled = false;
      /* a blank choice is not sent - the order says "Font line 2" only when
         line 2 really has a font of its own */
      sel.addEventListener('change', function(){
        useFont(this.value || (fontIn && fontIn.value));
      });
      f.appendChild(lab);
      f.appendChild(sel);
      lineFonts.appendChild(f);
    }
  }
  /* blank line-fonts stay out of the order */
  document.addEventListener('submit', function(){
    if (!lineFonts) return;
    [].forEach.call(lineFonts.querySelectorAll('[data-line-font]'), function(s){
      s.disabled = !s.value;
      /* the form's data is taken during this event; after it the customer must
         still be able to change their mind if the submit goes nowhere */
      setTimeout(function(){ s.disabled = false; }, 0);
    });
  }, true);
  function fontFor(i){
    var sel = lineFonts && lineFonts.querySelector('[data-line-font="' + i + '"]');
    return chosenFont(sel && sel.value ? sel.value : null);
  }

  function say(msg, working){
    if (status) status.textContent = msg;
    if (spin) spin.hidden = !working;
  }

  var MAXLINES = 4;
  function lines(){
    if (!textIn) return [];
    return String(textIn.value || '').split(/\r?\n/)
      .map(function(l){ return l.replace(/\s+/g, ' ').trim(); })
      .filter(function(l){ return l.length; })
      .slice(0, MAXLINES);
  }

  /* keep one text piece per line, and keep what the customer did to it */
  function syncTexts(){
    var ls = lines();
    while (texts.length > ls.length) texts.pop();
    while (texts.length < ls.length){
      texts.push({ s: '', size: 1, dx: 0, dy: 0, rot: 0, touched: false, rect: null });
    }
    ls.forEach(function(s, i){ texts[i].s = s; });
    if (selText >= texts.length) selText = texts.length ? texts.length - 1 : -1;
    return ls.length;
  }

  function engraving(){ return lines().join(' '); }

  /* --- the picture itself ------------------------------------------------ */

  /* The preview is drawn to the SHAPE of the window it is going into. One
     square picture cannot serve 35 windows whose proportions run from 0.35 (the
     tower) to 2.0 (the wide paperweight): fitted inside, it floats in the middle
     with a gap all round - the client's "kisi me bhi image fit nhi arhi";
     cropped to fill, the engraved line at its foot is the first thing cut off.
     So there is one drawing per shape, and each window's CSS names the one it
     wants. Five of them, from tune-engraving-windows.py's own buckets. */
  var BUCKETS = { b1: 0.40, b2: 0.75, b3: 1.02, b4: 1.40, b5: 2.00 };

  /* Where the engraved lines may go, by the letter after the bucket in a
     window's --b (tune-engraving-windows.py's TEXT table): [how much of the
     width, where the lines end]. A circle or a heart is narrow at its foot, so
     a line set across the very bottom is cut by the shape itself. */
  var LAYOUT = { '': [0.90, 1], n: [0.60, 0.95], h: [0.50, 0.80] };
  var CARD = 600;                /* the grid's tiles are ~330px - no need for more */

  function draw(ratio, keep, cls, edge){
    edge = edge || EDGE;
    var lay = LAYOUT[cls || ''] || LAYOUT[''];
    var w = ratio >= 1 ? edge : Math.round(edge * ratio);
    var h = ratio >= 1 ? Math.round(edge / ratio) : edge;
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var x = c.getContext('2d');
    var n = texts.length;
    var band = n ? h * Math.min(0.46, BAND + 0.10 * (n - 1)) : 0;
    var ph = (n ? h * lay[1] : h) - band;   /* what the photographs get */

    layers.forEach(function(L){
      var img = (L.cutout && L.cut) ? L.cut : L.img;
      if (!img || !img.width) return;
      /* fit, never fill: cropping the sides off a family is the one thing a
         preview must not do - the window itself is already the right shape */
      var s = Math.min(w / img.width, ph / img.height) * 0.98 * L.zoom;
      var cx = w / 2 + L.dx * w;
      var cy = ph / 2 + L.dy * h;
      x.save();
      x.translate(cx, cy);
      x.rotate(L.rot * Math.PI / 180);
      x.drawImage(img, -img.width * s / 2, -img.height * s / 2,
                  img.width * s, img.height * s);
      x.restore();
      if (keep){
        /* where it landed, as a fraction of the drawing, so a finger on the
           picture knows which one it grabbed. A quarter turn swaps the sides. */
        var w2 = img.width * s / 2, h2 = img.height * s / 2;
        if (L.rot % 180){ var t = w2; w2 = h2; h2 = t; }
        L.rect = [(cx - w2) / w, (cy - h2) / h, (cx + w2) / w, (cy + h2) / h];
        L.at = [L.dx, L.dy];
      }
    });

    /* The engraved lines belong INSIDE the crystal, and the way to have that on
       all 35 shapes is to put them in the same picture as the photographs: they
       land in the engraving window and take its clip, blend and blur with them. */
    if (n){
      var slot = band / n;
      x.fillStyle = '#ffffff';
      x.textAlign = 'center';
      x.textBaseline = 'middle';
      texts.forEach(function(T, i){
        var face = fontFor(i);             /* each line in its own font */
        var size = slot * 0.62 * T.size;
        x.font = size + 'px ' + face;
        while (size > 9 && x.measureText(T.s).width > w * lay[0]){
          size -= 1;
          x.font = size + 'px ' + face;
        }
        var tw = x.measureText(T.s).width;
        var tcx = w / 2 + T.dx * w;
        var tcy = ph + slot * (i + 0.5) + T.dy * h;
        x.save();
        x.translate(tcx, tcy);
        x.rotate(T.rot * Math.PI / 180);
        x.fillText(T.s, 0, 0);
        x.restore();
        if (keep){
          var tw2 = tw / 2, th2 = size * 0.72;
          if (T.rot % 180){ var t2 = tw2; tw2 = th2; th2 = t2; }
          T.rect = [(tcx - tw2) / w, (tcy - th2) / h, (tcx + tw2) / w, (tcy + th2) / h];
          T.at = [T.dx, T.dy];
        }
      });
    }
    return c;
  }

  /* "iski editing smoothly nhi horhi, kafi ziada load le rhi he". Every edit
     used to encode five 900px PNGs with toDataURL - on the main thread, so the
     page froze for each one - and hang megabytes of data: URL off <body>, which
     restyles the whole document. Now the canvas is encoded by toBlob, which the
     browser does off the main thread, into a WebP (PNG where WebP is not
     supported) behind a short blob: URL. One encode per shape in flight; a
     newer drawing waits for it instead of piling up. */
  var urls = {}, busy = {}, next = {}, gen = 0;
  function publish(k, c){
    if (busy[k]){ next[k] = c; return; }
    busy[k] = true;
    var mine = gen;
    c.toBlob(function(blob){
      busy[k] = false;
      if (blob && mine === gen){
        var old = urls[k], url = URL.createObjectURL(blob), st = document.body.style;
        urls[k] = url;
        st.setProperty('--photo-' + k, 'url("' + url + '")');
        /* the hero and the comp's own crystals still read --photo */
        if (k === 'b3') st.setProperty('--photo', 'url("' + url + '")');
        /* not at once - the old one may still be decoding in a tile */
        if (old) setTimeout(function(){ URL.revokeObjectURL(old); }, 3000);
      }
      var c2 = next[k];
      if (c2){ next[k] = null; publish(k, c2); }
    }, 'image/webp', 0.92);
  }

  /* The editor - the product page's preview, the upload page's stage - gets a
     drawing of its own, made to its window's EXACT shape (--photo-ed). Shared
     with the grid's bucket drawings it was cover-cropped to fit: the York
     award's 0.69 window showed a 0.75 drawing with its sides cut off, and the
     rects a finger is tested against were out by the same amount. */
  function editorEng(){
    return document.querySelector('.crystal[data-pdp-preview] .crystal__eng, [data-order-stage] .crystal__eng');
  }
  function kind(e){
    return (e && getComputedStyle(e).getPropertyValue('--b').trim()) || 'b3';
  }

  /* every drawing some window on this page asks for - b3 always, the hero
     and the comp's own crystals read --photo */
  function wanted(){
    var set = { b3: 1 };
    [].forEach.call(document.querySelectorAll('.crystal__eng'), function(e){ set[kind(e)] = 1; });
    return Object.keys(set);
  }

  function paint(only){
    var n = syncTexts();
    var st = document.body.style;
    if (!layers.length && !n){
      gen++; next = {};
      for (var i = st.length - 1; i >= 0; i--){
        if (st[i].indexOf('--photo') === 0) st.removeProperty(st[i]);
      }
      document.body.removeAttribute('data-has-photo');
      return;
    }
    var ed = editorEng(), r = ed && ed.getBoundingClientRect();
    if (r && r.width && r.height){
      publish('ed', draw(r.width / r.height, true, kind(ed).slice(2)));
    }
    if (!only){
      wanted().forEach(function(k){
        publish(k, draw(BUCKETS[k.slice(0, 2)] || 1, false, k.slice(2), k === 'b3' ? EDGE : CARD));
      });
    }
    document.body.setAttribute('data-has-photo', '');
  }
  document.addEventListener('cp:stage', function(){ if (layers.length || texts.length) paint(); });
  /* and whenever the editor comes out of hiding by any other road - a tab, a
     step, a resize - it draws itself, rather than relying on every road to say */
  if (window.ResizeObserver){
    var watch = new ResizeObserver(function(){
      var e = editorEng();
      if (e && e.getBoundingClientRect().width && (layers.length || texts.length)) repaint('ed');
    });
    [].forEach.call(document.querySelectorAll('[data-order-stage], .crystal[data-pdp-preview]'),
      function(el){ watch.observe(el); });
  }

  /* --- the design, on the order ------------------------------------------ */

  /* "jis tarha design kia k text ki position kaha he aur image ki position kaha
     he wo kaisy pata chalega admin ko?" - it did not: the arrangement lived in
     the browser and the order carried the photo and the words only. Now Add to
     cart first draws the crystal exactly as the preview shows it - the blank
     crystal, the photos and lines where the customer put them, cut to the
     window's shape - and attaches it as properties[Design preview], a file on
     the order like the photo itself. */

  /* the window, as fractions of the crystal, from the stylesheet rather than
     the screen: on the product page the preview is a tab, and a customer who
     arranged it and went back to the studio photos has a window of no size */
  function windowOf(eng){
    var name = [].filter.call(eng.classList, function(c){ return c.indexOf('eng--') === 0; })[0];
    var box = null;
    if (name){
      [].forEach.call(document.styleSheets, function(ss){
        var rules;
        try { rules = ss.cssRules; } catch (e){ return; }
        [].forEach.call(rules || [], function(r){
          if (r.selectorText === '.' + name && /%$/.test(r.style.width || '')) box = r.style;
        });
      });
    }
    if (box) return { l: parseFloat(box.left) / 100, t: parseFloat(box.top) / 100,
                      w: parseFloat(box.width) / 100, h: parseFloat(box.height) / 100,
                      clip: box.clipPath || box.webkitClipPath || '',
                      round: /50%/.test(box.borderRadius || '') };
    var c = eng.parentNode.getBoundingClientRect(), r = eng.getBoundingClientRect();
    if (!c.width || !r.width) return null;
    var cs = getComputedStyle(eng);
    return { l: (r.left - c.left) / c.width, t: (r.top - c.top) / c.height,
             w: r.width / c.width, h: r.height / c.height,
             clip: cs.clipPath, round: /^50%/.test(cs.borderTopLeftRadius) };
  }

  /* the same cut the CSS makes: a polygon, a traced heart, a circle, a box */
  function clipTo(x, win, X, Y, W, H){
    var p = /polygon\((.*)\)/.exec(win.clip || '');
    var u = /url\(["']?#([\w-]+)/.exec(win.clip || '');
    x.beginPath();
    if (p){
      p[1].split(',').forEach(function(pt, i){
        var v = pt.trim().split(/\s+/).map(parseFloat);
        x[i ? 'lineTo' : 'moveTo'](X + W * v[0] / 100, Y + H * v[1] / 100);
      });
      x.closePath();
      x.clip();
    } else if (u && document.getElementById(u[1]) && window.Path2D && window.DOMMatrix){
      var d = document.getElementById(u[1]).querySelector('path').getAttribute('d');
      var shape = new Path2D();
      shape.addPath(new Path2D(d), new DOMMatrix([W, 0, 0, H, X, Y]));
      x.clip(shape);
    } else {
      if (win.round) x.ellipse(X + W / 2, Y + H / 2, W / 2, H / 2, 0, 0, Math.PI * 2);
      else x.rect(X, Y, W, H);
      x.clip();
    }
  }

  function designFile(){
    return new Promise(function(done){
      var eng = editorEng();
      var win = eng && windowOf(eng);
      if (!win || (!layers.length && !texts.length)) return done(null);
      var art = eng.parentNode.querySelector('.crystal__art');
      var S = 1200, X = win.l * S, Y = win.t * S, W = win.w * S, H = win.h * S;
      var pic = draw(W / H, false, kind(eng).slice(2), 1000);
      function compose(withArt){
        var c = document.createElement('canvas');
        c.width = c.height = S;
        var x = c.getContext('2d');
        x.fillStyle = '#1b2733';
        x.fillRect(0, 0, S, S);
        if (withArt && art && art.naturalWidth) x.drawImage(art, 0, 0, S, S);
        x.save();
        clipTo(x, win, X, Y, W, H);
        x.globalCompositeOperation = 'screen';
        x.globalAlpha = 0.92;
        x.filter = 'grayscale(1) contrast(1.18) brightness(1.02)';
        x.drawImage(pic, X, Y, W, H);
        x.restore();
        c.toBlob(function(b){
          done(b ? new File([b], 'design-preview.jpg', { type: 'image/jpeg' }) : null);
        }, 'image/jpeg', 0.9);
      }
      /* a blank crystal from another origin taints the canvas and toBlob throws:
         then the design goes without the crystal behind it, never not at all */
      var ran = false;
      function run(){
        if (ran) return;
        ran = true;
        try { compose(true); } catch (e){
          try { compose(false); } catch (e2){ done(null); }
        }
      }
      /* the stage's crystal is a lazy <img> cloned a moment ago - a customer who
         picks a shape and presses Add to cart at once gets there before it has
         loaded, and the design went out on a blank backdrop */
      if (art && !art.naturalWidth && (art.currentSrc || art.src)){
        var fresh = new Image();
        var t = setTimeout(run, 4000);
        fresh.onload = function(){ clearTimeout(t); art = fresh; run(); };
        fresh.onerror = function(){ clearTimeout(t); run(); };
        fresh.src = art.currentSrc || art.src;
      } else {
        run();
      }
    });
  }

  /* THE ORDER GETS EVERY PHOTOGRAPH IN THE CRYSTAL. What the customer sees in
     the preview is what is sent: each photo as the file they picked when this
     page still has it, else the tray's copy - a photo shown from the tray used to
     reach the order as nothing ("only 2 of the uploaded images were saved"). The
     files go into the request itself, not onto file inputs: putting a file on an
     input needs DataTransfer, which some phones refuse, and a multiple-file input
     sends Shopify only its first file ("only 1 image is being uploaded").
     Capture phase, so this runs before the add-ons' own submit handler. */
  function layerFile(L, i){
    if (L.file) return Promise.resolve(L.file);
    if (L.name && CP_FILES[L.name]) return Promise.resolve(CP_FILES[L.name]);
    return fetch(L.thumb).then(function(r){ return r.blob(); }).then(function(b){
      var ext = /png/.test(b.type) ? '.png' : '.jpg';
      return new File([b], L.name || ('photo-' + (i + 1) + ext), { type: b.type || 'image/jpeg' });
    }).catch(function(){ return null; });
  }
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form.matches || !form.matches('#ProductForm, [data-order-form]')) return;
    if (!layers.length && !texts.length) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    /* the made-up sample pictures are never a customer's photograph */
    var samples = [].map.call(document.querySelectorAll('.chip--sample img'), function(im){ return im.src; });
    var real = layers.filter(function(L){ return L.file || samples.indexOf(L.thumb) < 0; });
    Promise.all([
      designFile().catch(function(){ return null; }),
      Promise.all(real.map(layerFile))
    ]).then(function(got){
      var design = got[0], photos = got[1].filter(Boolean);
      var main = form.querySelector('[data-photo-input]') || document.querySelector('[data-photo-input]');
      var slots = [(main && main.name) || 'properties[Your photo]'].concat(
        [].map.call(form.querySelectorAll('[data-photo-extra]'), function(el){ return el.name; }));
      /* the request, with the photographs at most `edge` px (none: only the
         ones too heavy to send as they are) */
      function request(edge){
        return Promise.all(photos.slice(0, slots.length).map(function(f){ return cpFitPhoto(f, edge); }))
          .then(function(fitted){
            var total = fitted.reduce(function(n, f){ return n + f.size; }, design ? design.size : 0);
            if (!edge && total > 17 * 1048576) return request(2600);
            var fd = new FormData(form);
            slots.forEach(function(n){ fd.delete(n); });
            fd.delete('properties[Design preview]');
            fitted.forEach(function(f, i){ fd.append(slots[i], f, f.name); });
            if (design) fd.append('properties[Design preview]', design, design.name);
            return fd;
          });
      }
      request(0).then(function(fd){
        cpCartAdd(form, fd, function(){ return request(2000); });
      });
    });
  }, true);

  /* one repaint per frame while a finger is on the picture, and only the shape
     being dragged: every drawing is encoded to a PNG, and that is not free */
  var queued = null;
  function repaint(only){
    if (queued){ queued = only; return; }
    queued = only || 'b3';
    requestAnimationFrame(function(){
      var k = queued; queued = null; paint(k);
    });
  }

  /* --- dragging the picture and the line of text ------------------------- */

  function inside(r, x, y){
    return r && x >= r[0] && x <= r[2] && y >= r[1] && y <= r[3];
  }

  /* Nothing may be dragged out of the window. The client: "we have a lot of
     space below but the text gets cut if I drag it down" - it was not being cut
     by anything except the edge of the engraving, and an edge you can push past
     invisibly is worse than one that simply holds. A tenth of the piece is
     allowed over the line, so a picture can still be pushed off-centre. */
  function hold(it){
    var r = it.rect;
    if (!r) return;
    /* the rect is from the last drawing, and a fast finger moves several times
       between two: carry it to where the piece is NOW, or the clamp tests a
       stale position and lets the line run off the crystal */
    var mx = it.dx - it.at[0], my = it.dy - it.at[1];
    r = [r[0] + mx, r[1] + my, r[2] + mx, r[3] + my];
    var w = r[2] - r[0], h = r[3] - r[1];
    /* half a letter over the edge is a cut letter - lines stop AT it */
    var k = texts.indexOf(it) >= 0 ? 0 : 0.10;
    var slackX = Math.min(w * k, 0.12), slackY = Math.min(h * k, 0.12);
    if (r[0] < -slackX) it.dx += -slackX - r[0];
    if (r[2] > 1 + slackX) it.dx -= r[2] - (1 + slackX);
    if (r[1] < -slackY) it.dy += -slackY - r[1];
    if (r[3] > 1 + slackY) it.dy -= r[3] - (1 + slackY);
  }

  /* crystalprints.com lets you take hold of the picture itself, so this does
     too - the arrows stay for anyone who wants them, or a keyboard. */
  document.addEventListener('pointerdown', function(e){
    if (e.button) return;
    var crystal = e.target && e.target.closest ? e.target.closest('.crystal') : null;
    if (!crystal) return;
    if (!crystal.hasAttribute('data-pdp-preview') && !crystal.closest('[data-order-stage]')) return;
    var eng = crystal.querySelector('.crystal__eng');
    if (!eng || (!layers.length && !texts.length)) return;

    var r = eng.getBoundingClientRect();
    if (!r.width || !r.height) return;
    /* the drawing is made to this window's shape, so the window IS the drawing:
       everything below is in fractions of it */
    var px = (e.clientX - r.left) / r.width;
    var py = (e.clientY - r.top) / r.height;

    var grabbed = null, i;
    for (i = texts.length - 1; i >= 0; i--){            /* the writing is on top */
      if (inside(texts[i].rect, px, py)){ grabbed = texts[i]; selText = i; break; }
    }
    if (!grabbed){
      for (i = layers.length - 1; i >= 0; i--){         /* topmost picture first */
        if (inside(layers[i].rect, px, py)){ grabbed = layers[i]; active = i; selText = -1; break; }
      }
      if (!grabbed && selText < 0) grabbed = layers[active];   /* empty space: the chosen one */
      if (!grabbed) return;
    }
    renderStrip(); label();

    e.preventDefault();
    var x0 = e.clientX, y0 = e.clientY;
    var sx = grabbed.dx, sy = grabbed.dy;
    grabbed.touched = true;

    function move(ev){
      grabbed.dx = sx + (ev.clientX - x0) / r.width;
      grabbed.dy = sy + (ev.clientY - y0) / r.height;
      hold(grabbed);
      repaint('ed');
    }
    function up(){
      document.removeEventListener('pointermove', move);
      document.removeEventListener('pointerup', up);
      document.removeEventListener('pointercancel', up);
      paint();
    }
    document.addEventListener('pointermove', move);
    document.addEventListener('pointerup', up);
    document.addEventListener('pointercancel', up);
  });

  /* --- which photograph the buttons are moving --------------------------- */

  function label(){
    var L = layers[active];
    if (btn){
      btn.textContent = (L && L.cutout && L.cut) ? 'Put the background back'
                                                 : 'Remove the background';
      btn.disabled = selText >= 0 || !L || !!L.busy;
    }
  }

  /* The strip is what the buttons are pointed at: every photograph in the
     crystal, then every line of engraving. */
  function renderStrip(){
    if (!strip) return;
    strip.innerHTML = '';
    strip.hidden = (layers.length + texts.length) < 2;
    layers.forEach(function(L, i){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'player';
      b.setAttribute('aria-pressed', (selText < 0 && i === active) ? 'true' : 'false');
      b.setAttribute('aria-label', 'Photo ' + (i + 1));
      b.innerHTML = '<img alt=""><span class="player__n">' + (i + 1) + '</span>' +
                    '<span class="player__x" role="presentation">&times;</span>';
      b.querySelector('img').src = L.thumb;
      b.onclick = function(e){
        if (e.target.className === 'player__x') drop(i);
        else { active = i; selText = -1; renderStrip(); label(); }
      };
      strip.appendChild(b);
    });
    texts.forEach(function(T, i){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'player player--text';
      b.setAttribute('aria-pressed', i === selText ? 'true' : 'false');
      b.setAttribute('aria-label', 'Engraved line ' + (i + 1));
      b.textContent = T.s.slice(0, 9) || ('Line ' + (i + 1));
      b.onclick = function(){ selText = i; renderStrip(); label(); };
      strip.appendChild(b);
    });
  }

  /* two photographs on top of each other help nobody: anything the customer has
     not moved themselves is laid out in a row, and stops being moved for them
     the moment they touch it */
  function arrange(){
    var n = layers.length;
    layers.forEach(function(L, i){
      if (L.touched) return;
      L.zoom = n > 1 ? 1 / n : 1;
      L.dx = n > 1 ? (i + 0.5) / n - 0.5 : 0;
      L.dy = 0;
      L.rot = 0;
    });
  }

  function drop(i){
    var L = layers.splice(i, 1)[0];
    if (L && L.file && L.thumb){ try { URL.revokeObjectURL(L.thumb); } catch(e){} }
    if (active >= layers.length) active = Math.max(0, layers.length - 1);
    arrange(); renderStrip(); syncInputs(); label(); paint();
    if (!layers.length && !texts.length){ bar.hidden = true; say(baseNote, false); }
  }

  function load(url, then){
    var i = new Image();
    i.crossOrigin = 'anonymous';
    i.onload = function(){ then(i); };
    i.onerror = function(){ say('That image could not be read.', false); };
    i.src = url;
  }

  /* A photograph is known by its URL AND its file name. The tray keeps a data:
     URL and the form's own input a blob: URL, so the same sameer.jpg arrived
     twice under two addresses and sat in the crystal twice - "if we're not
     cancelling the image tou woh 2 images show kar raha hy". And loading is
     async, so two calls in a row both passed the check before either landed:
     `loading` closes that gap. */
  var loading = {};
  function add(url, file, auto, name){
    name = name || (file && file.name) || '';
    for (var i = 0; i < layers.length; i++){
      if (layers[i].thumb === url || (name && layers[i].name === name)) return;
    }
    if (loading[url] || (name && loading['n:' + name])) return;
    loading[url] = 1;
    if (name) loading['n:' + name] = 1;
    load(url, function(img){
      delete loading[url];
      delete loading['n:' + name];
      var L = { img: img, cut: null, cutout: false, busy: false, touched: false,
                zoom: 1, dx: 0, dy: 0, rot: 0, thumb: url, file: file || null, name: name };
      layers.push(L);
      active = layers.length - 1;
      bar.hidden = false;
      say(baseNote, false);
      arrange(); renderStrip(); syncInputs(); label(); paint();
      /* the model is a big download; on a metered or 2G connection it waits to
         be asked for */
      var net = navigator.connection || {};
      var thin = net.saveData || /(^|-)2g$/.test(net.effectiveType || '');
      if (auto && !thin) cutout(L, true);
    });
  }

  /* --- taking the background out ----------------------------------------- */

  /* Hand the model a small picture. It works at 1024px internally anyway, and a
     modern phone photo is 4000px across - decoding that into a tensor is where a
     slower machine runs out of memory and the whole thing fails. */
  function shrunk(L, then){
    var LIMIT = 1024;
    var img = L.img;
    var s = Math.min(1, LIMIT / Math.max(img.width, img.height));
    if (s === 1 || !img.width){ then(img.src); return; }
    try {
      var c = document.createElement('canvas');
      c.width = Math.round(img.width * s);
      c.height = Math.round(img.height * s);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      c.toBlob(function(b){ then(b || img.src); }, 'image/png');
    } catch (e) { then(img.src); }   /* tainted canvas - send the URL instead */
  }

  /* Background removal runs in the browser: the photo never leaves the machine.
     It starts by itself the moment a photo is chosen, and the button then turns
     into the way back to the photo as uploaded. If the model cannot load, the
     plain-backdrop fallback has a go, and failing that the preview carries on
     with the photo as it is - nothing about the order depends on it, the artists
     cut every order out by hand anyway. */
  function cutout(L, auto){
    if (!L) return;
    if (L.cut){ L.cutout = !L.cutout; label(); paint(); return; }
    if (L.busy) return;
    L.busy = true;
    label();
    say('Taking the background out of your photo… the first one takes about half a '
      + 'minute while the tool loads, after that it is quick.', true);

    /* NO progress callback here, however much the wait deserves a percentage:
       the library does its work in a Web Worker and the config is cloned into
       it, and a function cannot be cloned - passing one fails the whole job with
       "Failed to fetch". Proved on the live store: the same photo goes through
       without it and fails with it, every time. So the reassurance is a clock. */
    var step = 0;
    var tick = setInterval(function(){
      step++;
      if (step === 1) say('Getting the background remover ready… it is a few '
        + 'megabytes the first time, then it stays.', true);
      else if (step === 2) say('Reading your photo…', true);
      else say('Still working — a big photo on a slow machine takes a moment.', true);
    }, 9000);
    function done(){ clearInterval(tick); }

    shrunk(L, function(input){
      cpLoadRemover()
        .then(function(m){
          /* default publicPath on purpose: 1.5.5 ships an empty resources.json, so
             pointing it at the npm package makes it look for models that are not
             there. The library's own CDN has them. */
          return m.removeBackground(input).catch(function(){
            /* One retry down a different road: the fast path runs on the GPU and
               there are machines whose driver throws there, and it pulls the full
               model where a slow line gives up. CPU and the small model are what
               works everywhere, just slower. */
            say('Still working on it — taking the slower, surer way…', true);
            return m.removeBackground(input, { device: 'cpu', model: 'isnet_quint8' });
          });
        })
        .then(function(blob){
          done();
          load(URL.createObjectURL(blob), function(i){
            L.cut = cpTrim(i, EDGE);
            L.cutout = true; L.busy = false;
            label();
            say('Background removed — this is how it will be engraved. Press the '
              + 'button to see your photo as you uploaded it.', false);
            paint();
          });
        })
        .catch(function(e){
          done();
          L.busy = false;
          /* say what went wrong: a blocked CDN, no memory and a slow line all
             looked identical from the old message, and that cost a round trip */
          if (window.console) console.error('[crystal] background removal failed', e);
          var flat = cpFlatCut(L.img, EDGE);
          if (flat){
            L.cut = cpTrim(flat, EDGE);
            L.cutout = true;
            label();
            say('Plain background taken out for the preview. Our artists cut your '
              + 'photo out by hand on the order itself.', false);
            paint();
            return;
          }
          label();
          var why = (e && e.message) ? (' (' + String(e.message).slice(0, 70) + ')') : '';
          say((auto
            ? 'Your photo is in the crystal. We could not take the background out in your browser'
            : 'Could not remove the background in your browser') + why
            + ' — our artists do it by hand on every order anyway.', false);
        });
    });
  }

  /* --- the files that reach the order ------------------------------------ */

  var input  = document.querySelector('[data-photo-input]');
  var extras = [].slice.call(document.querySelectorAll('[data-photo-extra]'));
  var MAX = 1 + extras.length;

  /* Shopify attaches one file per property, so the photographs are dealt out
     across one input each, in the order they are arranged in the preview. */
  function syncInputs(){
    if (!input || !owns) return;
    var files = [];
    layers.forEach(function(L){ if (L.file) files.push(L.file); });
    function put(el, f){
      try {
        var dt = new DataTransfer();
        if (f) dt.items.add(f);
        el.files = dt.files;
      } catch (e){}
    }
    put(input, files[0]);
    extras.forEach(function(el, i){ put(el, files[i + 1]); });
    cpPaintFile(files[0] || null, files.length > 1
      ? (files.length + ' photos attached to your order') : null);
  }

  if (input) input.addEventListener('change', function(){
    var picked = [].slice.call(input.files || []).filter(function(f){
      return /^image\//.test(f.type);
    });
    if (!picked.length) return;
    owns = true;
    /* choosing a photo that is already in the crystal - from the tray, or
       picked here before - swaps it for this copy instead of adding a second */
    picked.forEach(function(f){
      for (var i = layers.length - 1; i >= 0; i--){
        if (layers[i].name === f.name) layers.splice(i, 1);
      }
    });
    if (active >= layers.length) active = Math.max(0, layers.length - 1);
    picked.forEach(function(f){
      if (layers.length < MAX) add(URL.createObjectURL(f), f, true);
    });
    arrange(); renderStrip(); syncInputs(); label(); paint();
  });

  var clear = document.querySelector('[data-photo-clear]');
  if (clear) clear.addEventListener('click', function(){
    for (var i = layers.length - 1; i >= 0; i--){
      if (layers[i].file) layers.splice(i, 1);
    }
    owns = false;
    active = 0;
    arrange(); renderStrip(); label(); paint();
    if (!layers.length) bar.hidden = true;
  });

  /* the upload page keeps its photographs in the tray, and every one of them is
     in the crystal - pressing a chip there is what chooses the one to move */
  function fromTray(auto){
    var chips = [].slice.call(
      document.querySelectorAll('[data-strip] .chip:not(.chip--add)'));
    var srcs = [], names = [];
    chips.forEach(function(c){
      var im = c.querySelector('img');
      if (!im) return;
      srcs.push(im.src);
      names.push((c.getAttribute('aria-label') || '').replace(/^Preview\s+/, ''));
    });
    for (var i = layers.length - 1; i >= 0; i--){
      if (!layers[i].file && srcs.indexOf(layers[i].thumb) < 0) layers.splice(i, 1);
    }
    if (active >= layers.length) active = Math.max(0, layers.length - 1);
    srcs.slice(0, MAX).forEach(function(s, k){ add(s, null, auto, names[k]); });
    if (!layers.length){ bar.hidden = true; paint(); }
    else { renderStrip(); label(); paint(); }
  }
  if (document.querySelector('[data-strip]')){
    document.addEventListener('cp:photo', function(){ fromTray(true); });
    fromTray(false);                       /* a tray restored on page load */
  }

  if (textIn) textIn.addEventListener('input', function(){
    var n = syncTexts();
    syncFontPickers();
    if (n && selText < 0 && !layers.length) selText = 0;
    if (n || layers.length) bar.hidden = false;
    renderStrip(); label(); paint();
  });
  if (textIn && textIn.value){ syncTexts(); syncFontPickers(); }   /* autofilled */

  /* the buttons drive whatever is selected - a photograph or a line of text.
     Zoom is the text's size control, which is what the client asked for. */
  bar.addEventListener('click', function(e){
    var b = e.target.closest('[data-ptool]');
    if (!b) return;
    var what = b.getAttribute('data-ptool');
    var T = selText >= 0 ? texts[selText] : null;
    var L = layers[active];
    if (what === 'cutout'){ if (!T) cutout(L); return; }

    var it = T || L;
    if (!it) return;
    it.touched = true;
    if (what === 'zoom-in'){
      if (T) T.size = Math.min(3, T.size * 1.12);
      else L.zoom = Math.min(4, L.zoom * 1.15);
    } else if (what === 'zoom-out'){
      if (T) T.size = Math.max(0.35, T.size / 1.12);
      else L.zoom = Math.max(0.12, L.zoom / 1.15);
    }
    else if (what === 'left')  it.dx -= 0.04;
    else if (what === 'right') it.dx += 0.04;
    else if (what === 'up')    it.dy -= 0.04;
    else if (what === 'down')  it.dy += 0.04;
    else if (what === 'rotate') it.rot = (it.rot + 90) % 360;
    else if (what === 'reset'){
      if (T){ T.size = 1; T.dx = 0; T.dy = 0; T.rot = 0; T.touched = false; }
      else { L.touched = false; arrange(); }
    }
    if (what !== 'reset') hold(it);      /* the arrows stop at the edge too */
    paint();
  });
}


/* --------------------------------------------------------------------------
   HEADER SEARCH. The magnifying glass used to load /search; it opens a field in
   the header instead, and suggests products as you type through Shopify's own
   predictive search. The icon stays an <a href="/search">, so without
   JavaScript nothing is lost - this only intercepts the click.
   -------------------------------------------------------------------------- */
function initSearch(){
  var panel = document.getElementById('HeaderSearch');
  var toggle = document.querySelector('[data-search-toggle]');
  if (!panel || !toggle) return;

  var input = panel.querySelector('[data-search-input]');
  var out   = panel.querySelector('[data-search-results]');
  var timer = null, controller = null;

  function open(v){
    panel.hidden = !v;
    toggle.setAttribute('aria-expanded', v ? 'true' : 'false');
    if (v) setTimeout(function(){ input.focus(); }, 30);
  }

  toggle.addEventListener('click', function(e){
    e.preventDefault();
    open(panel.hidden);
  });
  var x = panel.querySelector('[data-search-close]');
  if (x) x.addEventListener('click', function(){ open(false); });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && !panel.hidden) open(false);
  });

  /* suggestions. /search/suggest.json is Shopify's own endpoint - no app, no
     index to maintain, and it respects the store's own search settings. */
  function suggest(q){
    if (controller) controller.abort();
    controller = new AbortController();
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { signal: controller.signal })
      .then(function(r){ return r.json(); })
      .then(function(d){
        var items = ((((d.resources || {}).results || {}).products) || [])
          .filter(function(p){ return p.handle !== 'gift-wrap'; });   /* an option, not a product */
        if (!items.length){
          out.innerHTML = '<p class="hsearch__none">Nothing matched &ldquo;' +
            q.replace(/[<>&]/g, '') + '&rdquo;. Try a shape - heart, cube, keychain.</p>';
          out.hidden = false;
          return;
        }
        out.innerHTML = items.map(function(p){
          var img = p.featured_image && p.featured_image.url
            ? '<img src="' + p.featured_image.url + '" alt="" width="52" height="52">' : '';
          return '<a class="hsug" href="' + p.url + '">' + img +
                 '<span><b>' + String(p.title).replace(/\s*\(design online\)/i, '') + '</b><em>' + (p.price || '') + '</em></span></a>';
        }).join('');
        out.hidden = false;
      })
      .catch(function(){});
  }

  input.addEventListener('input', function(){
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2){ out.hidden = true; out.innerHTML = ''; return; }
    timer = setTimeout(function(){ suggest(q); }, 220);
  });
}


/* --------------------------------------------------------------------------
   ADD-ONS: a light base, gift wrap, anything with a price of its own.

   A line-item property cannot change what a customer is charged, so an add-on
   has to be a real product on its own cart line. The crystal goes first, as a
   normal multipart POST, because that is the only way its photo file reaches
   the order; the add-ons follow as one /cart/add.js call.

   With nothing ticked this does not run at all and the form submits natively.

   It used to be wired to the product page's form only, so a light base or gift
   wrap picked on the upload page never reached the cart ("If you add any
   options and go to your cart - they are not there"). Both forms now.
   -------------------------------------------------------------------------- */
/* the add-ons picked in a form - a field hidden for this product is disabled
   and does not count */
function addonPicks(form){
  var out = [];
  [].forEach.call(form.querySelectorAll('input[data-addon]'), function(cb){
    if (cb.checked && !cb.disabled) out.push(cb);
  });
  [].forEach.call(form.querySelectorAll('[data-addon-select]'), function(sel){
    var o = sel.options[sel.selectedIndex];
    if (!sel.disabled && o && o.getAttribute('data-addon')) out.push(o);
  });
  return out;
}

/* the shop's own money format, for a total Liquid cannot know in advance */
function cpMoney(cents){
  var f = String((window.CP && window.CP.moneyFormat) || '${{amount}}').replace(/<[^>]*>/g, '');
  function num(d, th, dec){
    var p = (cents / 100).toFixed(d).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return p.join(dec);
  }
  return f.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
    if (k === 'amount_no_decimals') return num(0, ',', '.');
    if (k === 'amount_with_comma_separator') return num(2, '.', ',');
    if (k === 'amount_no_decimals_with_comma_separator') return num(0, '.', ',');
    return num(2, ',', '.');
  });
}

/* "Product price does not change when you add options": the price shown is the
   crystal's plus every add-on picked, each of which is its own cart line */
function cpTotal(form){
  if (!form) return;
  var sel = form.querySelector('[data-variant-select], #OrderSize');
  var o = sel && sel.options[sel.selectedIndex];
  if (!o || !o.hasAttribute('data-cents')) return;
  var cents = +o.getAttribute('data-cents');
  addonPicks(form).forEach(function(a){ cents += +a.getAttribute('data-cents') || 0; });
  /* not form.id: the form's own <select name="id"> shadows that property */
  var outs = form.getAttribute('id') === 'ProductForm'
    ? document.querySelectorAll('b[data-price], span[data-price]')
    : form.querySelectorAll('[data-order-price]');
  [].forEach.call(outs, function(el){ el.textContent = cpMoney(cents); });
}

/* CART: an add-on drawn inside its crystal has no quantity box of its own - a
   hidden one follows the crystal's, and "Remove" takes both. Without this the
   crystal's own link still removes the crystal, and the add-on then shows as a
   line of its own that can be removed by itself. */
function initCartGroups(){
  var form = document.querySelector('form.cart');
  if (!form) return;
  function follow(){
    [].forEach.call(form.querySelectorAll('[data-follow]'), function(f){
      var lead = form.querySelector('[data-lead="' + f.getAttribute('data-follow') + '"]');
      if (lead) f.value = lead.value;
    });
  }
  form.addEventListener('submit', follow, true);
  [].forEach.call(form.querySelectorAll('[data-remove-lead]'), function(a){
    a.addEventListener('click', function(e){
      var lead = form.querySelector('[data-lead="' + a.getAttribute('data-remove-lead') + '"]');
      if (!lead) return;
      e.preventDefault();
      lead.value = 0;
      var btn = form.querySelector('[name="update"]');
      if (form.requestSubmit) form.requestSubmit(btn || undefined);
      else { follow(); form.submit(); }
    });
  });
}

/* Shopify refuses a whole request over about 20MB (413), and four photographs
   straight off a phone can be that. A photograph heavier than 5MB goes in at
   4000px on its longest side - several times what the largest crystal engraves -
   and `edge` forces every one down to that size. */
function cpFitPhoto(f, edge){
  if (!f || (!edge && f.size < 5 * 1048576)) return Promise.resolve(f);
  edge = edge || 4000;
  return new Promise(function(done){
    var url = URL.createObjectURL(f), img = new Image();
    img.onload = function(){
      var s = Math.min(1, edge / Math.max(img.naturalWidth, img.naturalHeight));
      var c = document.createElement('canvas');
      c.width = Math.round(img.naturalWidth * s);
      c.height = Math.round(img.naturalHeight * s);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      c.toBlob(function(b){
        done(b && b.size < f.size ? new File([b], f.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }) : f);
      }, 'image/jpeg', 0.92);
    };
    img.onerror = function(){ URL.revokeObjectURL(url); done(f); };
    img.src = url;
  });
}

/* Puts a crystal in the cart from a prepared request - the form's fields plus
   the photographs and the design file - then its add-ons as NESTED lines of it
   (parent_line_key), so Shopify's own checkout, which the theme cannot touch,
   shows them under the crystal and drops them with it. The crystal and its
   add-ons also share a hidden group id for the cart page ("agr kisi ne 2 product
   add kiay aur ek k sath giftwrap ... pata kaisy chalega k kis k sath he").
   Underscore properties never show at checkout; "For" does, and in admin. */
function cpCartAdd(form, fd, again){
  /* the photographs this request carries: each must come back on the line */
  var expect = [];
  fd.forEach(function(v, k){
    if (typeof v === 'object' && v && v.size && /^properties\[/.test(k)) expect.push(k.slice(11, -1));
  });
  var retrying = false;
  function retry(key){
    retrying = true;
    var drop = key
      ? fetch('/cart/change.js', { method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }) })
      : Promise.resolve();
    return drop.then(again).then(function(fd2){ cpCartAdd(form, fd2, null); });
  }
  var picks = addonPicks(form);
  var cp = window.CP || {}, r = cp.routes || {};
  var btn = form.querySelector('[type="submit"]');
  if (btn) btn.disabled = true;
  /* one base, one wrap per crystal */
  var qty = Math.max(1, parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1);
  var group = '';
  if (picks.length){
    group = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var tag = form.querySelector('input[name="properties[_addons]"]');
    if (!tag){
      tag = document.createElement('input');
      tag.type = 'hidden';
      tag.name = 'properties[_addons]';
      form.appendChild(tag);
    }
    tag.value = group;
    fd.set('properties[_addons]', group);
  }
  var named = form.querySelector('[data-order-title]') || document.querySelector('.buy h1');
  var forWhat = ((named && named.textContent) || '').trim();

  var added = false;
  fetch(r.cartAdd || '/cart/add', {
    method: 'POST', body: fd,
    headers: { 'Accept': 'application/json' }
  }).then(function(res){
    if (res.status === 413 && again) return retry(null);
    if (!res.ok) throw new Error('crystal not added');
    added = true;
    return res.json().catch(function(){ return {}; });
  }).then(function(line){
    if (retrying) return;
    /* a photograph Shopify did not keep: take the line out, send it smaller */
    var kept = (line && line.properties) || {};
    if (again && line && line.key && expect.some(function(k){ return !kept[k]; })) return retry(line.key);
    if (!picks.length) return;
    var parent = line && (line.key || (line.items && line.items[0] && line.items[0].key));
    function addons(nested){
      return fetch((r.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: picks.map(function(p){
          var props = { _for: group };
          if (forWhat) props.For = forWhat;
          var it = { id: +p.getAttribute('data-addon'), quantity: qty, properties: props };
          if (nested) it.parent_line_key = parent;
          return it;
        }) })
      });
    }
    /* a store where nesting is refused still gets the add-ons, side by side */
    return addons(!!parent).then(function(res){
      return res.ok || !parent ? res : addons(false);
    });
  }).then(function(){
    if (!retrying) window.location.href = r.cart || '/cart';
  }).catch(function(){
    if (retrying) return;
    /* whatever went wrong, the customer still gets the crystal in the cart -
       and only once */
    if (added){ window.location.href = r.cart || '/cart'; return; }
    if (btn) btn.disabled = false;
    form.submit();
  });
}

function initAddons(){
  initCartGroups();
  document.addEventListener('change', function(e){
    var t = e.target;
    if (t.matches && t.matches('[data-addon], [data-addon-select]')) cpTotal(t.form);
  });

  [].forEach.call(document.querySelectorAll('#ProductForm, [data-order-form]'), function(form){
    form.addEventListener('submit', function(e){
      if (!addonPicks(form).length) return;  /* nothing extra: let it submit */
      e.preventDefault();
      cpCartAdd(form, new FormData(form));
    });
  });
}


/* --------------------------------------------------------------------------
   UPLOAD PAGE, steps 2 and 3.

   The comp's shape cards were links: picking a shape left the page. They are
   buttons now, and this fills step 3 from whichever one is pressed - the
   preview, the title, the size picker Liquid rendered for that product, the
   price - then the form posts to /cart/add like any product form.

   The size picker is cloned out of the hidden <select> next to each card, so
   variant ids and money formatting stay in Liquid where they belong.
   -------------------------------------------------------------------------- */
function initShapePick(){
  var form = document.querySelector('[data-order-form]');
  var cards = [].slice.call(document.querySelectorAll('[data-shape]'));
  if (!form || !cards.length) return;

  var stage    = document.querySelector('[data-order-stage]');
  var titleOut = form.querySelector('[data-order-title]');
  var sizeWrap = form.querySelector('[data-order-size]');
  var sizeSlot = form.querySelector('[data-order-variant]');
  var priceOut = form.querySelector('[data-order-price]');
  var link     = form.querySelector('[data-order-link]');
  /* the fields come from snippets/option-field.liquid now, the same ones the
     product page renders, so the hooks are the shared ones */
  var photo    = form.querySelector('[data-photo-input]');
  var extras   = [].slice.call(form.querySelectorAll('[data-photo-extra]'));

  function price(sel){
    var o = sel.options[sel.selectedIndex];
    if (o && priceOut) priceOut.textContent = o.getAttribute('data-price') || '';
    cpTotal(form);
  }

  /* The options are the product page's, but not every crystal takes all of
     them - no light base on a keychain, a chain only on a pendant. Each field
     carries its "Only on" / "Not on" tag lists; the card carries its product's
     tags and handle. A field that does not apply is hidden AND disabled, so
     nothing of it reaches the order. */
  function scope(card){
    var mine = (card.getAttribute('data-tags') || '').split(',').map(function(t){ return t.trim(); });
    function has(t){ return mine.indexOf(t) > -1; }
    function list(f, a){
      return (f.getAttribute(a) || '').toLowerCase().split(',')
        .map(function(t){ return t.trim(); }).filter(Boolean);
    }
    [].forEach.call(form.querySelectorAll('[data-only], [data-hide]'), function(f){
      var only = list(f, 'data-only');
      var on = (!only.length || only.some(has)) && !list(f, 'data-hide').some(has);
      f.hidden = !on;
      [].forEach.call(f.querySelectorAll('input, select, textarea'), function(el){
        el.disabled = !on;
        /* engraved text on a crystal that takes none would still be drawn
           into the preview and the design file */
        if (!on && el.matches('[data-engraved-text]') && el.value){
          el.value = '';
          el.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    });
  }

  function pick(card){
    cards.forEach(function(c){
      c.setAttribute('aria-pressed', c === card ? 'true' : 'false');
    });

    /* the preview is the card's own crystal - same photo, same engraving window */
    var art = card.querySelector('.crystal');
    if (stage && art){
      /* the engraved line is drawn into the photo itself now, inside the
         engraving window - there is nothing to append here any more */
      stage.innerHTML = '';
      stage.appendChild(art.cloneNode(true));
    }

    var tpl = form.querySelector('[data-order-template]');
    if (tpl){
      tpl.value = card.getAttribute('data-template') || '';
      tpl.disabled = !tpl.value;
    }

    if (titleOut) titleOut.textContent = card.getAttribute('data-title') || '';
    if (link) link.href = card.getAttribute('data-url') || link.href;
    scope(card);

    var src = document.querySelector('[data-shape-opts="' + card.getAttribute('data-shape') + '"] select');
    if (src && sizeSlot){
      var sel = src.cloneNode(true);
      sel.className = 'select';
      sel.id = 'OrderSize';
      sel.addEventListener('change', function(){ price(sel); });
      sizeSlot.innerHTML = '';
      sizeSlot.appendChild(sel);
      /* one variant is not a choice - the select still submits the id */
      if (sizeWrap) sizeWrap.hidden = sel.options.length < 2;
      price(sel);
    }

    document.body.setAttribute('data-shape-picked', '');
    /* AFTER the step is shown: the editor's drawing is made to its window's
       exact size, and a window still inside a display:none step has none - it
       used to be sent before, so the photo never appeared until it was chosen
       again ("koi bhi template select kar rahe hen tou woh image show nae kar
       raha") */
    document.dispatchEvent(new CustomEvent('cp:stage'));
    fillPhoto();
    setTimeout(function(){
      form.scrollIntoView({ behavior:'smooth', block:'start' });
    }, 90);
  }

  cards.forEach(function(card){
    card.addEventListener('click', function(){ pick(card); });
  });

  var change = form.querySelector('[data-order-change]');
  if (change) change.addEventListener('click', function(){
    var shapes = document.getElementById('shapes');
    if (shapes) shapes.scrollIntoView({ behavior:'smooth', block:'start' });
  });

  /* THE PHOTO.
     The tray is data URLs in localStorage; an order needs a real file on a real
     input, and the only way to put one there is DataTransfer. The tray preview
     is capped at 720px - too small to engrave from - so the customer's original
     File is used whenever it is still in this page's memory, and when it is not
     (a tray restored from a previous visit) the note says so plainly. */
  var originals = {};                       /* name -> the File as picked */
  var picker = document.getElementById('filePicker');
  if (picker) picker.addEventListener('change', function(){
    [].forEach.call(picker.files || [], function(f){ originals[f.name] = f; });
  });

  function put(el, file){
    try {
      var dt = new DataTransfer();
      if (file) dt.items.add(file);
      el.files = dt.files;
      return true;
    } catch(e){ return false; }
  }

  /* Every photograph in the tray is in the crystal, so every one of them has to
     reach the order - one file per input, the same way the product page deals
     them out. The tray's own copies are shrunk to 720px, too small to engrave
     from, so the customer's File is used wherever this page still holds it and
     the note says plainly when it does not. */
  function fillPhoto(){
    if (!photo) return;
    if (photo.files && photo.files.length && !photo.hasAttribute('data-from-tray')) return;

    var chips = [].slice.call(
      document.querySelectorAll('[data-strip] .chip:not(.chip--add)')).slice(0, 1 + extras.length);
    if (!chips.length){
      put(photo, null);
      extras.forEach(function(el){ put(el, null); });
      cpPaintFile(null);
      return;
    }
    photo.setAttribute('data-from-tray', '');

    var jobs = chips.map(function(chip){
      var name = (chip.getAttribute('aria-label') || '').replace(/^Preview\s+/, '');
      if (originals[name]) return Promise.resolve(originals[name]);
      var img = chip.querySelector('img');
      if (!img) return Promise.resolve(null);
      return fetch(img.src).then(function(r){ return r.blob(); }).then(function(b){
        return new File([b], name || 'your-photo.jpg', { type: b.type || 'image/jpeg' });
      }).catch(function(){ return null; });
    });

    Promise.all(jobs).then(function(files){
      files = files.filter(Boolean);
      put(photo, files[0] || null);
      extras.forEach(function(el, i){ put(el, files[i + 1] || null); });
      if (!files.length){ cpPaintFile(null); return; }
      var fromTray = files.some(function(f){ return !originals[f.name]; });
      cpPaintFile(files[0], files.length > 1
        ? (files.length + ' photos attached to your order')
        : (fromTray
            ? 'Attached from your tray. We email you for the original full-resolution '
              + 'file before we start, or choose it again here.'
            : 'Attached: ' + files[0].name));
    });
  }

  if (photo) photo.addEventListener('change', function(){
    photo.removeAttribute('data-from-tray');
  });

  /* swapping the picture in the tray swaps what is attached */
  document.addEventListener('cp:photo', function(){ fillPhoto(); });
}
